"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _emotionTheming = require("emotion-theming");

var _space = _interopRequireDefault(require("../../../styles/space"));

var _Card = require("./Card.style");

var _Card2 = _interopRequireDefault(require("./Card"));

var _helpers = require("../../../utils/helpers");

var _Typography = require("../../Typography");

var _CardSignpostText = require("./CardSignpostText.style");

var CardSignpostText = function CardSignpostText(_ref) {
  var copy = _ref.copy,
      image = _ref.image,
      label = _ref.label,
      title = _ref.title,
      link = _ref.link,
      banner = _ref.banner;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  return /*#__PURE__*/_react.default.createElement(_Card2.default, {
    url: link === null || link === void 0 ? void 0 : link.url
  }, /*#__PURE__*/_react.default.createElement(_Card.Wrapper, {
    image: image
  }, banner && copy && /*#__PURE__*/_react.default.createElement(_Card.CardBanner, banner), image && /*#__PURE__*/_react.default.createElement(_Card.Overlay, null, /*#__PURE__*/_react.default.createElement(_Card.CardImage, Object.assign({
    preserveStackingContext: true,
    mediaType: "backgroundImage"
  }, image), /*#__PURE__*/_react.default.createElement(_CardSignpostText.CardSignpostTextLabel, null, label && /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    size: "small",
    as: "h3"
  }, label), title && /*#__PURE__*/_react.default.createElement(_CardSignpostText.CardSignpostTextTitle, {
    mb: _space.default.xsmall
  }, title)))), copy && /*#__PURE__*/_react.default.createElement(_Card.CardContent, {
    image: image
  }, /*#__PURE__*/_react.default.createElement(_rebass.Box, {
    height: "4.8rem"
  }, /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    size: cards.copyTextSize
  }, (0, _helpers.ellipsify)(copy, 90))))));
};

CardSignpostText.propTypes = {
  /** Card copy - placed under the title */
  copy: _propTypes.default.string,
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),

  /** Card image label */
  label: _propTypes.default.string,

  /** Card Primary CTA - links to main title and image */
  title: _propTypes.default.string,
  link: _propTypes.default.shape({
    /** card link URL */
    url: _propTypes.default.string
  }),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  })
};
CardSignpostText.defaultProps = {
  copy: '',
  label: '',
  title: '',
  link: null,
  image: null,
  banner: null
};
var _default = CardSignpostText;
exports.default = _default;